export enum OLD_PHONE_TYPES {
  HOME = 'Home',
  MOBILE = 'Cell',
  WORK = 'Work'
}

export enum PHONE_TYPES {
  HOME = 'home',
  MOBILE = 'mobile',
  WORK = 'work'
}

export const FROM_LEGACY_TO_PHONE: Record<OLD_PHONE_TYPES, PHONE_TYPES> = {
  [OLD_PHONE_TYPES.HOME]: PHONE_TYPES.HOME,
  [OLD_PHONE_TYPES.MOBILE]: PHONE_TYPES.MOBILE,
  [OLD_PHONE_TYPES.WORK]: PHONE_TYPES.WORK
};

export const FROM_PHONE_TO_LEGACY: Record<PHONE_TYPES, OLD_PHONE_TYPES> = {
  [PHONE_TYPES.HOME]: OLD_PHONE_TYPES.HOME,
  [PHONE_TYPES.MOBILE]: OLD_PHONE_TYPES.MOBILE,
  [PHONE_TYPES.WORK]: OLD_PHONE_TYPES.WORK
};
